<template>
  <v-dialog v-model="show" max-width="450">
    <v-card>
      <v-card-title style="word-break: normal" class="pl-10 pb-5">
        Registro de No Cliente
      </v-card-title>
      <v-card-text>
        <NonCustomerRecordForm
          :loading="loading"
          :fathers-name-required="fathersNameRequired"
          :mothers-name-required="mothersNameRequired"
          @onRegisterCustomer="handleRegisterCustomer"
          @onCancelRegisterCustomer="cancelRegisterCustomer"
          ref="nonCustomerRecordForm"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import NonCustomerRecordForm from '../forms/NonCustomerRecordForm';
export default {
  name: 'NonCustomerRecordModal',
  components: {
    NonCustomerRecordForm,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    fathersNameRequired: {
      type: String,
      default: 'required',
    },
    mothersNameRequired: {
      type: String,
      default: 'required',
    },
  },
  data: () => ({
    show: false,
  }),
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
      this.$refs.nonCustomerRecordForm.resetForm();
    },
    handleRegisterCustomer(payload) {
      this.$emit('onRegisterCustomer', payload);
    },
    cancelRegisterCustomer() {
      this.$emit('cancelRegisterCustomer');
      this.show = false;
      this.$refs.nonCustomerRecordForm.resetForm();
    },
  },
};
</script>

<style></style>
